export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string?.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getMonthDayYear = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });
  const day = date.getDate();

  return { year, month, day };
};

export const SETTINGS = {
  PROFILE: "Profile",
  NOTIFICATIONS: "Notifications",
  AUTHENTICATION: "Authentication",
  BILLING: "Billing",
  SYSTEM_UPDATES: "System Updates"
};

export const getSettingNavItems = ({ isNotificationAllowed, isAuthenticationAllowed, isBillingAllowed, isSystemUpdatesAllowed }) => {
  return [
    { label: SETTINGS.PROFILE },
    isNotificationAllowed ? { label: SETTINGS.NOTIFICATIONS } : null,
    isAuthenticationAllowed ? { label: SETTINGS.AUTHENTICATION } : null,
    isBillingAllowed ? { label: SETTINGS.BILLING } : null,
    isSystemUpdatesAllowed ? { label: SETTINGS.SYSTEM_UPDATES } : null,
  ].filter(Boolean);
}

